<template>
    <v-card hover flat>
        <v-form ref="form" v-model="valid" lazy-validation enctype="multipart/form-data">
            <v-card-title>
                <h3 class="headline mb-0"><span style="color: #9C1A1A">{{ tipo === 'editar' ? 'Editar Papel' : tipo === 'crear' ? 'Nuevo Lote' : 'Ficha del papel' }}</span></h3>
            </v-card-title>
            <v-card-text>
                <v-text-field
                    ref="lote"
                    prepend-icon="code"
                    v-model="form.lote"
                    :rules="[v => !!v || 'Lote es requerido']"
                    :error-messages="errLote"
                    label="Lote"
                    required
                ></v-text-field>

                <v-text-field
                    v-if="tipo === 'editar'"
                    ref="papel"
                    mask="##########"
                    prepend-icon="code"
                    v-model="form.papel"
                    :rules="[v => !!v || 'Num Papel es requerido']"
                    label="Número Papel"
                    required
                ></v-text-field>

                <!-- <v-switch
                  v-if="tipo === 'editar'"
                  color="primary"
                  v-model="form.asignado"
                  label="Usado"
                ></v-switch>
                <v-switch
                  v-if="tipo === 'editar'"
                  color="primary"
                  v-model="form.anulado"
                  label="Cancelado"
                ></v-switch> -->

                <v-text-field
                    v-if="tipo === 'crear'"
                    ref="papel_desde"
                    mask="##########"
                    prepend-icon="code"
                    v-model="form.start_in"
                    :rules="[v => !!v || 'Papel Desde es requerido']"
                    label="Papel Desde"
                    required
                ></v-text-field>

                <v-text-field
                    v-if="tipo === 'crear'"
                    ref="papel_hasta"
                    mask="##########"
                    prepend-icon="code"
                    v-model="form.end_in"
                    :rules="[v => !!v || 'Papel Hasta es requerido']"
                    label="Papel Hasta"
                    required
                ></v-text-field>

            </v-card-text>
            <v-card-actions>
                <v-btn @click="cerrarDialog(null)">Cerrar</v-btn>
                <v-spacer></v-spacer>
                <v-btn v-if="tipo !== 'ver'" :loading="loading" class="primary" @click="submit">{{ tipo === 'editar' ? 'Actualizar' : tipo === 'crear' ? 'Crear': 'Ver' }}</v-btn>
            </v-card-actions>
        </v-form>
      </v-card>
</template>

<script>
import axios from 'axios'
import Form from 'vform'

export default {

    props: {
        tipo: {
            type: String,
            required: true
        },
        datos: {
            type: Object,
            required: true
        }
    },

    watch: {
        datos(v) {
            this.$refs.form.resetValidation()
            if (this.tipo == "crear") {
                Object.assign(this.form, this.formOld)
            }else {
                Object.assign(this.form, v)
            }
        }
    },

  data: () => ({
    errPapel: [],
    errLote: [],
    valid: false,
    loading: false,
    form: new Form({
        id: '',
        lote: '',
        papel: '',
        start_in: '',
        end_in: '',
        asignado: false,
        anulado: false,
    }),
    formOld:{
        id: '',
        lote: '',
        papel: '',
        start_in: '',
        end_in: '',
        asignado: false,
        anulado: false,
    }
  }),

  mounted() {
    this.$store.dispatch('clearMessage')
  },

  methods: {

    submit () {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.submitFormPapers()
      }
    },

    async submitFormPapers () {
      try {
        if (this.tipo == 'crear') {
          const { data } = await axios.post('/api/administration/cobranza/create_paper', this.form)
          this.cerrarDialog(data)
        }else {
          const { data } = await axios.patch('/api/administration/cobranza/update_paper', this.form)
          this.cerrarDialog(data)
        }
      } catch (e) {
        console.log(e.response, 'data error create')
        this.loading = false
        if (e.response.data.errors) {
          this.form.errors.errors = e.response.data.errors
          if (e.response.data.errors.papel) {
            this.$refs.papel.focus()
            this.$store.dispatch('responseMessage', {
              type: 'error',
              text: e.response.data.errors.papel[0]
            })
          }else if (e.response.data.errors.lote) {
            this.$refs.lote.focus()
            this.$store.dispatch('responseMessage', {
              type: 'error',
              text: e.response.data.errors.lote[0]
            })
          }else if (e.response.data.errors.security_paper) {
            this.$refs.lote.focus()
            this.$store.dispatch('responseMessage', {
              type: 'error',
              text: e.response.data.errors.security_paper
            })
          }
        }else {
          this.$store.dispatch('responseMessage', {
            type: 'error',
            text: e.response.data.error
          })
        }
      }

    },

    cerrarDialog (data) {
        this.$emit('closeDialogRole', data)
        this.$nextTick(() => {
            this.$refs.form.resetValidation()
            this.loading = false
        })
    }

  }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/cobranza/FormPapers.vue